import React from "react";
import RootRouter from "./rootRouter";
import { View } from "react-native";
import Spinner from "./src/containers/Spinner";
import { connect } from "react-redux";
import { SafeAreaProvider } from "react-native-safe-area-context";
function RootSpiner(props) {
  return (
    <View style={{ flex: 1 }}>
      <SafeAreaProvider>
        <RootRouter />
      </SafeAreaProvider>
      {props.spinner && (
        <View
          style={{
            position: "absolute",
            left: 0,
            right: 0,
            top: 0,
            bottom: 0,
            opacity: 0.9,
            backgroundColor: "white",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Spinner />
        </View>
      )}
    </View>
  );
}

const mapStateToProps = (state) => {
  const spinner = state.spinner && state.spinner;
  return { spinner };
};
export default connect(mapStateToProps)(RootSpiner);
